@let site = site$ | async;
@defer (when site) {
    <div class="flex flex-col">
        <h5>Specific Services</h5>
        @let stipend = stipend$.source$ | async;
        @let reimbursement = reimbursement$.source$ | async;
        @let travel = travel$.source$ | async;
        @let other = other$.source$ | async;
        @let isAnyOptionSelected = stipend || reimbursement || travel || other;
        <div [class.hidden]="elevatedAccess() || isAnyOptionSelected">No specific service option selected</div>

        @if (mode() === 'edit') {
            <medpace-form-errors [formControlWithErrors]="formGrp()" [style]="'alert'" />
        }

        @if (elevatedAccess() || site.services.travel) {
            <div class="flex flex-col">
                <mds-checkbox
                    id="travelSupportCheckbox"
                    [formCtrl]="formGrp().controls.travelSupportControl"
                    [label]="'Travel Support'"
                    name="travel"
                />
                @if (travelRequestsPresent$.source$ | async) {
                    <span class="flex ml-4" [id]="'travel-support-warning'">
                        Option cannot be edited due to pending travel requests related to this site
                    </span>
                }
            </div>
        }

        @if (elevatedAccess() || site.services.reimbursement) {
            <mds-checkbox
                id="reimbursementCheckbox"
                [formCtrl]="formGrp().controls.reimbursementControl"
                [label]="'Reimbursement'"
                name="reimbursement"
            />
        }

        @if (elevatedAccess() || site.services.stipend) {
            <mds-checkbox
                id="stipendCheckbox"
                [formCtrl]="formGrp().controls.stipendControl"
                [label]="'Stipend'"
                name="stipend"
            />
        }
        <!-- use [class.hidden] instead of @if because the condition can change quickly and class.hidden doesn't cause a recompilation -->
        <medpace-stipend-visits
            class="p-medpace"
            [class.hidden]="!stipend"
            [site]="site"
            [mode]="mode()"
            [formGrp]="formGrp().controls.stipendVisits"
        />

        @if (elevatedAccess() || site.services.other) {
            <mds-checkbox
                id="otherCheckbox"
                [formCtrl]="formGrp().controls.otherControl"
                [label]="'Other'"
                name="other"
            />
        }

        <mds-text-field
            [class.hidden]="!other"
            class="p-medpace"
            [id]="'otherDetails'"
            [label]=""
            [placeholder]="'E.g. Site requires handling all Reimbursements. Country restricts caregivers from receiving payment…'"
            name="otherDetails"
            [appearance]="'outline'"
            [inputType]="'text'"
            [formCtrl]="formGrp().controls.otherDetails"
        />
    </div>
}
